// CustomTextFields.tsx
import React from 'react';
import TextField from '@mui/material/TextField';
import { titleInputTextFieldSxStyles, subtitleInputTextField2SxStyles } from './styles';

interface CustomTitleInputTextFieldProps {
    label: string;
    value: string | number;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    maxLength?: number;
}

export const CustomTitleInputTextField: React.FC<CustomTitleInputTextFieldProps> = ({
    label,
    value,
    onChange,
    disabled,
    maxLength = 500,
}) => {
    return (
        <TextField
            label={label}
            value={value}
            onChange={onChange}
            disabled={disabled}
            variant="outlined"
            fullWidth
            InputProps={{
                inputProps: {
                    maxLength: maxLength,
                    style: {
                        textAlign: 'right',
                        // color: '#2099B4',
                        fontSize: '18px',
                    },
                },
            }}
            helperText={maxLength && !disabled ? `${String(value).length}/${maxLength}` : ''}
            sx={titleInputTextFieldSxStyles(label.length)}
        />
    );
};

interface CustomSubtitleInputTextFieldProps {
    label: string;
    value: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    d?: number;
}

export const CustomSubtitleInputTextField: React.FC<CustomSubtitleInputTextFieldProps> = ({
    label,
    value,
    onChange,
    d = 150,
    disabled,
}) => {
    return (
        <TextField
            label={label}
            value={value}
            onChange={onChange}
            disabled={disabled}
            variant="outlined"
            fullWidth
            InputProps={{
                inputProps: {
                    style: {
                        textAlign: 'right',
                        color: 'rgba(0, 0, 0, 0.9)',
                        fontSize: '16px',
                        padding: '3px',
                        paddingBottom: '0',
                        paddingTop: '6px',
                        borderBottom: '1.5px solid #d3d3d3',
                    },
                },
            }}
            sx={subtitleInputTextField2SxStyles(d)}
        />
    );
};

export const CustomNumberInputTextField: React.FC<CustomTitleInputTextFieldProps> = ({ label, value, onChange, disabled }) => {
    return (
        <TextField
            id="outlined-number"
            label={label}
            type="number"
            defaultValue={value}
            onChange={onChange}
            disabled={disabled}
            sx={{
                width: '200px',
                ...titleInputTextFieldSxStyles(14.42),
                '& .MuiInputBase-input': {
                    padding: '9px',
                    paddingRight: '18px',
                    color: 'black',
                },
            }}
        />
    );
};

interface CustomTextAreaInputTextFieldProps {
    label: string;
    value: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    d?: number;
    maxLength?: number;
}

export const CustomTextAreaInputTextField: React.FC<CustomTextAreaInputTextFieldProps> = ({
    label,
    value,
    onChange,
    d = 150,
    disabled,
    maxLength = 5000,
}) => {
    return (
        <TextField
            label={label}
            value={value}
            onChange={onChange}
            disabled={disabled}
            variant="outlined"
            fullWidth
            multiline
            rows={3}
            InputProps={{
                inputProps: {
                    maxLength: maxLength,
                    style: {
                        textAlign: 'right',
                        color: 'rgba(0, 0, 0, 0.9)',
                        fontSize: '16px',
                        padding: '10px',
                        border: '1.5px solid #d3d3d3',
                        borderRadius: '10px',
                        backgroundColor: 'white',
                    },
                },
            }}
            helperText={maxLength && !disabled ? `${String(value).length}/${maxLength}` : ''}
            sx={{
                ...subtitleInputTextField2SxStyles(d),
            }}
        />
    );
};
